import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

import RFQIntro from 'apps/rfq/rfqPage/views/rfqIntro';
import DetailsBlock from 'apps/rfq/rfqPage/views/detailsBlock';
// import NewQuoteForm from 'apps/quote/views/newQuoteForm';
// import ForwardedQuotes from 'apps/quote/views/forwardedQuotes';
import NeedPerfectQuote from 'apps/rfq/rfqPage/views/needPerfectQuote';

const ManufacturerRFQPage = observer(props => {
  const { rfqManager, quotesManager } = props;
  const { rfqApp } = rfqManager;
  // const { quoteFormStore } = quotesManager;
  // const quoteFormRef = useRef(null);
  const forwardedQuotesRef = useRef(null);
  useEffect(() => {
    quotesManager.forwardedQuotesRef = forwardedQuotesRef;
  }, []);

  return (
    <>
      <RFQIntro rfqManager={rfqManager} rfqApp={rfqApp} isManufacturer />
      <NeedPerfectQuote rfqManager={rfqManager} />;
      <DetailsBlock rfqManager={rfqManager} jobSpec={rfqApp.jobSpec} />
      {/* <ForwardedQuotes
        isManufacturer
        quotesManager={quotesManager}
        quoteFormRef={quoteFormRef}
        forwardedQuotesRef={forwardedQuotesRef}
      /> */}
      {/* <NewQuoteForm quoteFormStore={quoteFormStore} formRef={quoteFormRef} /> */}
    </>
  );
});

ManufacturerRFQPage.propTypes = {
  rfqManager: PropTypes.object,
  quotesManager: PropTypes.object,
};

export default withNamespaces()(ManufacturerRFQPage);
